export default __webpack_public_path__ + "static/media/main.3c07aa92.gif";